import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form, FormGroup } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import Loader from '../../../common/Loader';
import FormItem from '../../../common/forms/FormItem';
import FormFooter from '../../../common/forms/FormFooter';
import TextInput from '../../../common/forms/input/TextInput';
import { isRequired } from '../../../../utils/validators';
import RegionSelect from '../../../common/forms/select/RegionSelect';


export const CityForm = ({ handleSubmit, loading }) => {
    if (loading) return <Loader />;
    
    return (
        <Form onSubmit={handleSubmit}>
        <FormGroup row>
            <FormItem label="Nombre" required>
            <Field
                name="name"
                component={TextInput}
                placeholder="Nombre"
                validate={[isRequired]}
            />
            </FormItem>
        </FormGroup>
        <FormGroup row>
        <FormItem label="Región" required>
          <Field
            name="selectedRegion"
            component={RegionSelect}
            type='text'
            validate={[isRequired]}
          />
        </FormItem>
        </FormGroup>
        <FormFooter />
        </Form>
    );
}



CityForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

const mapStateToProps = ({ LocationUnit }) => ({
  loading: !LocationUnit.District.getIn(['current', 'activity']).isEmpty(),
});

CityForm.defaultProps = {
  loading: false,
};

const formComponent = reduxForm({
  form: 'CityForm',
})(CityForm);

export default connect(mapStateToProps)(formComponent);